/**
 * Photo Grid - click to play video in place
 * Each .photo-item.has-video swaps its thumbnail for an inline
 * autoplaying video (with sound) when clicked, and reverts back
 * to the thumbnail when the video ends or is clicked again.
 */
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".photo-item.has-video");
  if (!items.length) return;

  let activeItem = null;

  function stopItem(item) {
    const video = item.querySelector(".photo-video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    item.classList.remove("is-playing");
  }

  function playItem(item) {
    const video = item.querySelector(".photo-video");
    const src = item.getAttribute("data-video-src");
    if (!video || !src) return;

    if (activeItem && activeItem !== item) {
      stopItem(activeItem);
    }

    if (!video.getAttribute("src")) {
      video.setAttribute("src", src);
    }

    item.classList.add("is-playing");
    video.muted = false;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        // Browser blocked audio autoplay - fall back to muted playback
        video.muted = true;
        video.play().catch(() => {});
      });
    }

    activeItem = item;
  }

  items.forEach((item) => {
    const video = item.querySelector(".photo-video");

    item.addEventListener("click", (event) => {
      event.preventDefault();
      if (item.classList.contains("is-playing")) {
        stopItem(item);
        activeItem = null;
      } else {
        playItem(item);
      }
    });

    item.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        item.click();
      }
    });

    item.setAttribute("tabindex", "0");
    item.setAttribute("role", "button");

    if (video) {
      video.addEventListener("ended", () => {
        stopItem(item);
        if (activeItem === item) activeItem = null;
      });
    }
  });
});
